package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class PrescriptionApplicableSyndromeClassic(private val literal: String) : IEnumType {
	NA("NA"),
	太阳证("太阳证"),
	阳明证("阳明证"),
	少阳证("少阳证"),
	太阴证("太阴证"),
	少阴证("少阴证"),
	厥阴证("厥阴证"),
	风寒表实证("风寒表实证"),
	风寒表虚证("风寒表虚证"),
	风热表实证("风热表实证"),
	气虚外感证("气虚外感证"),
	里实寒证("里实寒证"),
	里虚寒证("里虚寒证"),
	里实热证("里实热证"),
	里虚热证("里虚热证"),
	虚实夹杂证("虚实夹杂证"),
	阴虚证("阴虚证"),
	阳虚证("阳虚证"),
	阳亢证("阳亢证"),
	亡阳证("亡阳证"),
	亡阴证("亡阴证"),
	上焦热盛证("上焦热盛证"),
	下焦虚寒证("下焦虚寒证"),
	血热证("血热证"),
	气分热盛证("气分热盛证"),
	气虚证("气虚证"),
	气陷证("气陷证"),
	气滞证("气滞证"),
	气逆证("气逆证"),
	血虚证("血虚证"),
	血瘀证("血瘀证"),
	气血两虚证("气血两虚证"),
	肾精不足证("肾精不足证"),
	津亏证("津亏证"),
	气阴两虚证("气阴两虚证"),
	水饮在表证("水饮在表证"),
	水饮内停证("水饮内停证"),
	寒饮伏肺证("寒饮伏肺证"),
	水气凌心证("水气凌心证"),
	寒湿证("寒湿证"),
	湿热证("湿热证"),
	痰热证("痰热证"),
	寒痰证("寒痰证"),
	痰湿证("痰湿证"),
	风痰证("风痰证"),
	痰气郁结证("痰气郁结证"),
	瘀热互结证("瘀热互结证"),
	寒凝血瘀证("寒凝血瘀证"),
	气滞血瘀证("气滞血瘀证"),
	风邪表证("风邪表证"),
	食积证("食积证"),
	食积湿热证("食积湿热证"),
	气郁证("气郁证"),
	火毒证("火毒证"),
	虫积证("虫积证"),
	温燥证("温燥证"),
	凉燥证("凉燥证"),
	暑湿证("暑湿证"),
	风湿证("风湿证");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "prescription_applicable_syndrome_classic"}
	override fun getLiteral(): String {return literal}
}
